import { SET_AVG_DEMAND_EVENT, SET_BALANCING, SET_QUALITY, SET_OFFSHORE_BALANCING, SET_FUEL_CONSUMPTION } from "./actionType";
const initialState = {
  avgDemandEvent: {},
  quality: {},
  balancing: {},
  offshoreBalancing: {},
  fuelConsumption: {},
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_AVG_DEMAND_EVENT:
      return { ...state, avgDemandEvent: payload };

    case SET_BALANCING:
      return { ...state, balancing: payload };

    case SET_OFFSHORE_BALANCING:
      return { ...state, offshoreBalancing: payload };

    case SET_QUALITY:
      return { ...state, quality: payload };

    case SET_FUEL_CONSUMPTION:
      return { ...state, fuelConsumption: payload };

    default:
      return state;
  }
};
